import { render, staticRenderFns } from "./TroubleMatchingModal.vue?vue&type=template&id=87c1dc44&scoped=true&"
import script from "./TroubleMatchingModal.vue?vue&type=script&lang=js&"
export * from "./TroubleMatchingModal.vue?vue&type=script&lang=js&"
import style0 from "./TroubleMatchingModal.vue?vue&type=style&index=0&id=87c1dc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c1dc44",
  null
  
)

export default component.exports